import { render } from "./Popovers.vue?vue&type=template&id=ff780c9e"
import script from "./Popovers.vue?vue&type=script&lang=js"
export * from "./Popovers.vue?vue&type=script&lang=js"

import "./Popovers.vue?vue&type=style&index=0&id=ff780c9e&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__